// Desktop collapse state classes, stamped on BOTH sidebar asides by
// application.js's applySidebarState() (any viewport ≤ 1200px — phones
// included) and by the #sidebar-toggle handler. Any code that reveals a
// sidebar in the mobile off-canvas drawer must strip these first: in the
// mobile media query, `.collapsed-sidebar`'s off-canvas transform ties
// `.show`'s on-canvas transform on specificity and beats it on source order,
// so a revealed sidebar still carrying the stamp stays off-screen.
export const COLLAPSED_CLASS = "collapsed-sidebar"
export const FOOTER_HIDDEN_CLASS = "sidebar-footer-hidden"
